const specificationSync = require("specification").SpecificationSync;

const createSpecification = function (isSatisfiedByFunction) {
    let specificationObject = function () {
    };
    specificationObject.prototype = Object.create(specificationSync);
    specificationObject.prototype.isSatisfiedBy = isSatisfiedByFunction;
    return specificationObject;
};

angular.module("FlexyBeautyApp.services")
    .factory("MarketPlaceSpecifications", ["BasicAuthRole",
        function (BasicAuthRole) {
            let specifications = {};

            specifications.MarketPlaceCompliant = createSpecification(
                (companyView, isManagerMode) => {
                    let marketplaceBasicAuthRole = BasicAuthRole.LE_CISEAU_ROLE;
                    return (marketplaceBasicAuthRole.isCompanyTypeCompliant(companyView)
                        && marketplaceBasicAuthRole.isCountryCompliant(companyView)
                        && marketplaceBasicAuthRole.isAccountTypeCompliant(companyView)
                        && isManagerMode);
                }
            );

            return specifications;
        }]
    );



// WEBPACK FOOTER //
// ./js/specifications/pro/MarketPlaceSpecifications.js